import { render, staticRenderFns } from "./tdqSlideUp.vue?vue&type=template&id=5c8651ae&scoped=true&"
import script from "./tdqSlideUp.vue?vue&type=script&lang=ts&"
export * from "./tdqSlideUp.vue?vue&type=script&lang=ts&"
import style0 from "./tdqSlideUp.vue?vue&type=style&index=0&id=5c8651ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8651ae",
  null
  
)

export default component.exports